import { Bell, Cloud, History, ShieldAlert, ShieldCheck } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header, Outcome } from "./AdminPagePrimitives";

import { useAdminIntegrationWorkspace } from "./useAdminIntegrationWorkspace";

export function IntegrationPage({notify}: {notify: Notify}) {
  const { health } = useAdminIntegrationWorkspace({notify});
  const mikro = health?.integrations?.connectors.find(
    (connector) => connector.code === "MICRO_ERP",
  );
  const connections = [
    {
      label: "Mikro ERP",
      detail: "Reçete, stok, depo ve transfer geçmişi · yalnız okuma",
      ready: mikro?.configured,
      icon: History,
    },
    {
      label: "Microsoft Entra ID",
      detail: "Tek kiracılı kurumsal kimlik doğrulama",
      ready: health?.authentication.configured,
      icon: ShieldCheck,
    },
    {
      label: "Azure PostgreSQL",
      detail: "Kullanıcı, süreç ve denetim verileri",
      ready: health?.database.reachable,
      icon: Cloud,
    },
    {
      label: "Microsoft Graph",
      detail: "Ortak posta kutusu bildirimleri",
      ready: health?.email.configured,
      icon: Bell,
    },
  ];
  return (
    <>
      <Header
        eyebrow="Kurumsal bağlantılar"
        title="Kurumsal Entegrasyon Durumu"
        description="Kimlik, veri ve bildirim servislerinin gerçek yapılandırma durumunu görüntüleyin."
      />
      <section className="connection-grid">
        {connections.map(({ label, detail, ready, icon: Icon }) => (
          <article key={label}>
            <span>
              <Icon size={19} />
            </span>
            <div>
              <h2>{label}</h2>
              <p>{detail}</p>
            </div>
            <Outcome value={ready ? "SUCCESS" : "NOT_CONFIGURED"} />
          </article>
        ))}
      </section>
      <section className="admin-guidance">
        {mikro?.configured ? <ShieldCheck size={20} /> : <ShieldAlert size={20} />}
        <div>
          <strong>
            {mikro?.configured
              ? "Mikro ERP salt okunur erişimi yapılandırılmış"
              : "Mikro ERP salt okunur erişimi yapılandırılmamış"}
          </strong>
          <p>
            {mikro?.configured
              ? "Panel Mikro verilerini karşılaştırma ve karar desteği için okuyabilir; transfer, fiş veya stok güncellemesi yapamaz. Bu gösterge yapılandırmayı doğrular, anlık bağlantı testinin yerini tutmaz."
              : "Reçete ve stok kontrolleri için gerekli güvenli bağlantı ayarları sunucuda tanımlanmalıdır."}
          </p>
        </div>
      </section>
    </>
  );
}
